import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_APARTMENT_LOCATOR_GET_APARTMENT_LEASES_BY_RENTER_USER_ID } from 'api/actionTypes';

export default function loadApartmentLeaseByRenterUserId({ state, apiClient }, { renterUserId }) {
  return apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_LOCATOR_GET_APARTMENT_LEASES_BY_RENTER_USER_ID,
    state: state,
    queryId: `${renterUserId}`,
    payload: {
      renterUserId,
    },
    onSuccess(apartmentLeases) {
      typeCheck('apartmentLeases::Array', apartmentLeases);
      state.set(['apartmentLocator', 'apartmentLeasesByUserId', renterUserId], apartmentLeases[0]);
    },
  });
}
